
import { Options, Vue, prop } from "vue-class-component";
import { PropType, ref } from "vue";
import LpInputSearch from "@/app/ui/components/lp-input-search/index.vue";
import SelectSearch from "@/app/ui/components/select-search/index.vue";
import { PhoneBookingV3 } from "@/domain/entities/CreateBookingV3";

class Props {
  options = prop<any[]>({
    default: [],
    type: Array
  });
  modelValue = prop<any>({
    required: true
  });
  customer = prop<any>({
    required: true
  });
  dataSearch = prop<any[]>({
    default: [],
    type: Array
  });
  onSearch = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  phone = prop<string>({
    default: "",
    type: String
  });
  customerName = prop<string>({
    default: "",
    type: String
  });
  code = prop<string>({
    default: "",
    type: String
  });
  error = prop<boolean>({
    default: false,
    type: Boolean
  });
  errorCaption = prop<string>({
    default: "Error",
    type: String
  });
  maxLength = prop<number>({
    default: 14,
    type: Number
  });
  format = prop<any>({
    default: null,
    type: Function
  });
  placeholder = prop<string>({
    default: "",
    type: String
  });
  prefixWidth = prop<string>({
    default: "w-20",
    type: String
  });
  disabled = prop<boolean>({
    default: false,
    type: Boolean
  });
  disabledUserDropdown = prop<boolean>({
    default: false,
    type: Boolean
  });
  isLoading = prop<boolean>({
    default: false,
    type: Boolean
  });
  isShowErrorMessage = prop<boolean>({
    default: true,
    type: Boolean
  });
  isShowIconEmpty = prop<boolean>({
    default: false,
    type: Boolean
  });
  errorMessage = prop<string>({
    default: "Apa yang Anda cari tidak ditemukan atau tidak ada.",
    type: String
  });
  keyValue = prop<string>({
    default: "value",
    type: String
  });
  allEnabled = prop<boolean>({
    default: false,
    type: Boolean
  });
  keyName = prop<string>({
    default: "name",
    type: String
  });
  searchCustomerNameMode = prop<boolean>({
    default: false,
    type: Boolean
  });
  countryCodeButtonId = prop<string>({
    default: "country-code-button"
  });
  phoneNumberFieldId = prop<string>({
    default: "phone-number-field"
  });
  isEditItem = prop<boolean>({
    default: false,
    type: Boolean
  });
  useInfiniteScroll = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  emits: ["change", "focus", "setValue", "pasteText", "update:code","editItem","update:customer", "update:customerName", "scrolled"],
  components: { LpInputSearch, SelectSearch },
  watch: {
    "searchCountryModel": function() {
      if (this.searchCountryModel) {
        this.codeProp = this.searchCountryModel.code;
        this.onChooseSearch(this.searchCountryModel);
      }
    },
  }
})
export default class SelectGroup extends Vue.with(Props) {

  onFilter = false;
  selectedIndex = -1;
  selectedEditIndex = -1;
  isCustomerMenuOpen = false;
  searchCountryString = "";
  searchCountryModel = new PhoneBookingV3();

  isOpenSearch = false;

  filterSearch =
    typeof this.modelValue === "object"
      ? this.modelValue[this.keyName]
      : this.modelValue;

  get customerNameModel() {
    return this.customerName;
  }

  set customerNameModel(value) {
    this.$emit("update:customerName", value);
  }

  get codeProp() {
    return this.code;
  }

  set codeProp(value) {
    this.$emit('update:code', value);
  }

  onOpenSearch() {
    if (this.disabled) return;

    this.isCustomerMenuOpen = false;
    this.isOpenSearch = !this.isOpenSearch;
    setTimeout(() => {
      if ((this.$refs['searchCountryRef'] as any)) {
        (this.$refs['searchCountryRef'] as any).onOpenSelect(true);
      }
    }, 200);
  }
  onCloseSearch() {
    this.isOpenSearch = false;
    this.isCustomerMenuOpen = false;
  }
  onChooseSearch(item: any) {
    this.$emit("setValue", item);
  }
  formatText(e: any) {
    const value = e.target.value;
    if (value.includes("*")) {
        this.$emit("change", value);
        return;
    }

    e.target.value = this?.format(e.target.value);
    this.$emit("change", e.target.value);
  }
  onFocus(e: any) {
    this.onCloseSearch();
    this.$emit("focus", e);
    this.onOpenSelect(true);
  }
  onBlur(e: any) {
    this.$emit("blur", e);
  }
  pasteText() {
    this.$emit("pasteText");
  }

  editItem(item: any) {
    this.onCloseSearch();
    this.$emit('editItem', item);
  }

  get dataOptions() {
    if (!this.onFilter) {
      return this.options;
    }
    const tempOptions = this.options.filter((option: any) => {
      return option[this.keyName]
        ? option[this.keyName]
            .toLowerCase()
            .includes(this.filterSearch.toLowerCase())
        : option.toLowerCase().includes(this.filterSearch);
    });
    if (this.allEnabled && !this.filterSearch) {
      const allObject: any = {};
      allObject[this.keyName] = "All";
      allObject[this.keyValue] = "all";
      tempOptions.unshift(allObject);
    }
    return tempOptions;
  }

  // logic for selected item
  isSelected(item: any) {
    return this.customer?.[this.keyValue]
      ? this.customer?.[this.keyValue] === item?.[this.keyValue]
      : this.customer === item || this.customer === item?.[this.keyValue] || this.customer?.[this.keyValue] === item?.[this.keyValue];
  }

  onChooseSelect(item: any) {
   // if (this.isSelected(item)) {
     // this.$emit("update:customer", {});
     // this.$emit("change", "");
     // this.filterSearch = "";
    //} else {
      this.$emit("update:customer", item);
      this.$emit("change", item[this.keyName]);
      this.filterSearch = item[this.keyName] || item;
   // }
    this.onOpenSelect(false);
  }

  onChoose(item: any) {
    this.$emit("update:customer", item);
    this.$emit("change", item[this.keyName]);
    this.filterSearch = item[this.keyName] || item;
  }

  onOpenSelect(value: boolean) {
    this.isOpenSearch = false;
    if (!value) {
      this.$emit("close", "");
      this.$emit("blur", "");
    }
    this.isCustomerMenuOpen = value;
  }

  highlightMatch(text: string): string {
    const searchText = this.searchCustomerNameMode
      ? this.customerName
      : this.code + this.phone;

    if (!searchText) {
      return text;
    }

    let escapedSearchText = searchText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    if (this.searchCustomerNameMode) {
      escapedSearchText = searchText;
    }

    // try {
    //   const regex = new RegExp(`(${escapedSearchText})`, "gi");
    //   const boldText = text.replace(regex, "<strong>$1</strong>");
    //   return boldText;
    // } catch (error) {
      return text.replace(searchText, `<strong>${searchText}</strong>`);
    // }
  }

  fetchNew({ target: { scrollTop } }: any) {
    if (scrollTop > 0 && this.useInfiniteScroll) {
      this.$emit("scrolled");
    }
  }

  onKeyUpAndDown(e: any) {
    const keyname = this.searchCustomerNameMode ? "customerName" : "customerPhoneNumber"
    const searchValue = this.searchCustomerNameMode ? this.customerNameModel : this.phone;

    if (e.key === "ArrowDown") {
      this.selectedIndex += 1;
    }
    if (e.key === "ArrowUp") {
      this.selectedIndex -= 1;
    }
    if (this.selectedIndex === this.dataOptions?.length) {
      this.selectedIndex = 0;
    }
    if (this.selectedIndex < 0) {
      this.selectedIndex = this.dataOptions?.length - 1;
    }
    if (!this.dataOptions[this.selectedIndex]) {
      this.selectedIndex = this.dataOptions.findIndex((option) => option[keyname] === searchValue);
      if (this.selectedIndex === -1) return
    }
    const item = this.dataOptions[this.selectedIndex]
    this.$emit("update:customer", item);
    this.$emit("change", item[keyname]);
    this.filterSearch = item[keyname] || item;
    const container: any = this.$refs.container;
    if (container) {
      const option: any = this.$refs[`option${this.selectedIndex}`];
      if (container.scroll) {
        container.scroll({
          top: option.offsetTop - option.offsetHeight
        });
      }
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.onCloseSearch();
      event.stopPropagation();
      return;
    }

    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      this.selectedEditIndex = -1;
      this.onKeyUpAndDown(event);
    }
    if (event.key === "Tab") {
      if (!this.isCustomerMenuOpen) return this.onOpenSelect(false);
      if (event.shiftKey && this.selectedEditIndex > -1) {
        event.preventDefault()
        this.selectedEditIndex = -1;
        return;
      } 
      if (this.isEditItem && this.selectedIndex > -1 && this.selectedIndex !== this.selectedEditIndex && !event.shiftKey) {
        event.preventDefault();
        this.selectedEditIndex = this.selectedIndex;
        return;
      }

      if (!this.isEditItem || this.selectedIndex === -1) return this.onOpenSelect(false);
      this.selectedEditIndex = -1;
      this.onOpenSelect(false);
    }

    if (event.key === " " && this.selectedIndex === this.selectedEditIndex) {
      this.onSpaceEdit(event);
    }

    if (event.key === "Enter") {
      this.onOpenSelect(false);
      const inputRef: any = this.$refs.searchCustomer;
      inputRef.blur();
    }
  }

  onSpaceEdit(event: KeyboardEvent) {
    if (this.selectedEditIndex) return;
    event.preventDefault();
    const dataItem = this.dataOptions[this.selectedIndex]
    if (!dataItem) return;
    this.editItem(dataItem);
  }

  async onFocusPhoneCode() {
    this.isOpenSearch = true;
    await this.$nextTick();
    (this.$refs.searchCountryRef as any).$refs.selectSearch?.focus();
  }

  onTabSearchCountry(event: KeyboardEvent) {
    event.preventDefault();
    (this.$refs.searchCustomer as any).focus();
  }

  onKeyDownCountryCode(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.onCloseSearch();
      event.stopPropagation();
      return;
    }

    if (event.key === " ") {
      this.onFocusPhoneCode();
    }
  }
}
